import {
  UPLOAD_STRUCTURE01_REQUEST,
  UPLOAD_STRUCTURE01_SUCCESS,
  UPLOAD_STRUCTURE01_FAILURE,
  UPLOAD_STRUCTURE02_REQUEST,
  UPLOAD_STRUCTURE02_SUCCESS,
  UPLOAD_STRUCTURE02_FAILURE,
  UPLOAD_STRUCTURE03_REQUEST,
  UPLOAD_STRUCTURE03_SUCCESS,
  UPLOAD_STRUCTURE03_FAILURE,
  UPLOAD_STRUCTURE04_REQUEST,
  UPLOAD_STRUCTURE04_SUCCESS,
  UPLOAD_STRUCTURE04_FAILURE,
  UPLOAD_STRUCTURE05_REQUEST,
  UPLOAD_STRUCTURE05_SUCCESS,
  UPLOAD_STRUCTURE05_FAILURE,
  UPLOAD_STRUCTURE09_REQUEST,
  UPLOAD_STRUCTURE09_SUCCESS,
  UPLOAD_STRUCTURE09_FAILURE,
  SAVE_OCR_PAYLOAD_REQUEST,
  SAVE_OCR_PAYLOAD_SUCCESS,
  SAVE_OCR_PAYLOAD_FAILURE,
} from "./ocrTypes";

// Structure 1 Upload Reducer
const initialStateForOcrStructure1 = {
  loading: false,
  ocrData: [],
  error: "",
};

const ocrUploadStructure1Reducer = (
  state = initialStateForOcrStructure1,
  action
) => {
  switch (action.type) {
    case UPLOAD_STRUCTURE01_REQUEST:
      return { ...state, loading: true };
    case UPLOAD_STRUCTURE01_SUCCESS:
      return { loading: false, ocrData: action.payload, error: "" };
    case UPLOAD_STRUCTURE01_FAILURE:
      return { loading: false, ocrData: [], error: action.payload };
    default:
      return state;
  }
};

// Structure 2 Upload Reducer
const initialStateForOcrStructure2 = {
  loading: false,
  ocrData: [],
  error: "",
};

const ocrUploadStructure2Reducer = (
  state = initialStateForOcrStructure2,
  action
) => {
  switch (action.type) {
    case UPLOAD_STRUCTURE02_REQUEST:
      return { ...state, loading: true };
    case UPLOAD_STRUCTURE02_SUCCESS:
      return { loading: false, ocrData: action.payload, error: "" };
    case UPLOAD_STRUCTURE02_FAILURE:
      return { loading: false, ocrData: [], error: action.payload };
    default:
      return state;
  }
};

// Structure 3 Upload Reducer
const initialStateForOcrStructure3 = {
  loading: false,
  ocrData: [],
  error: "",
};

const ocrUploadStructure3Reducer = (
  state = initialStateForOcrStructure3,
  action
) => {
  switch (action.type) {
    case UPLOAD_STRUCTURE03_REQUEST:
      return { ...state, loading: true };
    case UPLOAD_STRUCTURE03_SUCCESS:
      return { loading: false, ocrData: action.payload, error: "" };
    case UPLOAD_STRUCTURE03_FAILURE:
      return { loading: false, ocrData: [], error: action.payload };
    default:
      return state;
  }
};

// Structure 4 Upload Reducer
const initialStateForOcrStructure4 = {
  loading: false,
  ocrData: [],
  error: "",
};

const ocrUploadStructure4Reducer = (
  state = initialStateForOcrStructure4,
  action
) => {
  switch (action.type) {
    case UPLOAD_STRUCTURE04_REQUEST:
      return { ...state, loading: true };
    case UPLOAD_STRUCTURE04_SUCCESS:
      return { loading: false, ocrData: action.payload, error: "" };
    case UPLOAD_STRUCTURE04_FAILURE:
      return { loading: false, ocrData: [], error: action.payload };
    default:
      return state;
  }
};

// Structure 5 Upload Reducer
const initialStateForOcrStructure5 = {
  loading: false,
  ocrData: [],
  error: "",
};

const ocrUploadStructure5Reducer = (
  state = initialStateForOcrStructure5,
  action
) => {
  switch (action.type) {
    case UPLOAD_STRUCTURE05_REQUEST:
      return { ...state, loading: true };
    case UPLOAD_STRUCTURE05_SUCCESS:
      return { loading: false, ocrData: action.payload, error: "" };
    case UPLOAD_STRUCTURE05_FAILURE:
      return { loading: false, ocrData: [], error: action.payload };
    default:
      return state;
  }
};

// Structure 9 Upload Reducer
const initialStateForOcrStructure9 = {
  loading: false,
  ocrData: [],
  error: "",
};

const ocrUploadStructure9Reducer = (
  state = initialStateForOcrStructure9,
  action
) => {
  switch (action.type) {
    case UPLOAD_STRUCTURE09_REQUEST:
      return { ...state, loading: true };
    case UPLOAD_STRUCTURE09_SUCCESS:
      return { loading: false, ocrData: action.payload, error: "" };
    case UPLOAD_STRUCTURE09_FAILURE:
      return { loading: false, ocrData: [], error: action.payload };
    default:
      return state;
  }
};

// Save Extracted Data Reducer
const initialStateForOcrSaveData = {
  loading: false,
  saveData: [],
  error: "",
};

const ocrSaveDataReducer = (state = initialStateForOcrSaveData, action) => {
  switch (action.type) {
    case SAVE_OCR_PAYLOAD_REQUEST:
      return { ...state, loading: true };
    case SAVE_OCR_PAYLOAD_SUCCESS:
      return { loading: false, saveData: action.payload, error: "" };
    case SAVE_OCR_PAYLOAD_FAILURE:
      return { loading: false, saveData: [], error: action.payload };
    default:
      return state;
  }
};

export {
  ocrUploadStructure1Reducer,
  ocrUploadStructure2Reducer,
  ocrUploadStructure3Reducer,
  ocrUploadStructure4Reducer,
  ocrUploadStructure5Reducer,
  ocrUploadStructure9Reducer,
  ocrSaveDataReducer,
};
